export const symbologyColors = {
    parapetWall: [107, 114, 128], // gray shade
    handrails: [107, 114, 128], // gray shade
    others: [168, 162, 158], // Gray light
    ridge: [107, 114, 128], // gray
  
    metal: [0, 0, 0], // black
  
    pipelines: [220, 38, 38], // redd shade 
    lightningArrester: [239, 68, 68], // redd shade 
    lifeline: [220, 38, 38], // redd shade 
    mumty_structure: [239, 68, 68], // redd shade
  
    moduleCleaningPipe: [59, 130, 246], // sky blue bright
    walkway: [59, 130, 246], // sky blue bright
    
    inverter: [239, 68, 68], // redd shade 
    helipad: [239, 68, 68], // redd shade 
    chimney: [255, 0, 0], // red 
    extendedColumns: [220, 38, 38], // red shade
    mobileTower: [239, 68 ,68], // redd shade
    
    skylight: [245, 158, 11], // yellow shade
    turbo: [245, 158, 11], // yellow shade
    hvac: [245, 158, 11], // yellow shade
  
    waterStorageTank: [132, 204, 22], // Parrot green shade
    trees: [132, 204, 22], // parrot green
  
    exisistingmodules: [147, 197, 253], // sky blue light

    roof: [255, 255, 255],
    roof_border: [255, 184, 104], 

    ac_earthing: [147, 197, 253], // sky blue light
    dc_earthing: [147, 197, 253], // sky blue light,


    panels: [0, 0, 139],
    highlight_border: [255, 105, 0],
  };